import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';

import { getBlogsEntities } from 'selectors';
import { fetchBlogs } from 'actions';
import { getLocaleUrlPath } from 'utils';

import ContentSection from 'components/ContentSection';

import { BLOGGERS } from 'constants/bloggers';
import {
  Title,
  ItemLink,
  Date,
  BlogsContent,
  BlogsButton,
  AuthorImg,
  AuthorContent,
  AuthorName,
  BlogsItemsWrapper,
} from './styles';

const Blogs = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage, locale } = intl;
  const blogsItems = useSelector(state => getBlogsEntities(state));

  useEffect(() => {
    return dispatch(fetchBlogs());
  }, [locale]);

  const renderItemLink = (key, value) => {
    return (
      <ItemLink key={value.link}>
        <BlogsContent>
          <Date>{value.date}</Date>

          <a
            href={`https://minfin.com.ua${getLocaleUrlPath(locale)}${
              value.link
            }`}
            target="_blank"
            rel="noopener noreferrer"
            title={value.name}
          >
            {value.name}
          </a>
        </BlogsContent>
        <AuthorContent
          href={`https://minfin.com.ua${getLocaleUrlPath(locale)}/users/${
            BLOGGERS[key].nick
          }/`}
          target="_blank"
          rel="noopener noreferrer"
          title=""
        >
          <AuthorImg src={BLOGGERS[key].img} alt="" />

          <AuthorName>{BLOGGERS[key].name}</AuthorName>
        </AuthorContent>
      </ItemLink>
    );
  };

  return Object.keys(blogsItems).length > 0 ? (
    <ContentSection>
      <Title
        href={`https://minfin.com.ua${getLocaleUrlPath(
          locale
        )}/forum/currency/`}
        target="_blank"
        rel="noopener noreferrer"
        title={formatMessage({ id: 'blogs.title' })}
      >
        {formatMessage({ id: 'blogs.title' })}
      </Title>

      <BlogsItemsWrapper>
        {Object.entries(blogsItems).map(([key, value]) => {
          return renderItemLink(key, value);
        })}
      </BlogsItemsWrapper>

      <BlogsButton
        href={`https://minfin.com.ua${getLocaleUrlPath(
          locale
        )}/forum/currency/`}
        target="_blank"
        rel="noopener noreferrer"
        title=""
      >
        {formatMessage({ id: 'blogs.button' })}
      </BlogsButton>
    </ContentSection>
  ) : null;
};

export default Blogs;
